var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('FieldContentContainer',{attrs:{"source":_vm.field.source,"is-active":_vm.isActive,"has-value":!_vm.field.value,"show-initials":_vm.showInitials}},[[_vm._v(_vm._s(_vm.initials))]],2)}
var staticRenderFns = []

export { render, staticRenderFns }